import { UseFormReturn } from 'react-hook-form';

import { CADFormModel, CAD_TYPES } from '../../../CAD.types';
import { Enum } from '../Enum';
import { Text } from '../Text';

export interface TypesProps {
	id: string;
	readOnly: boolean;
	rhf: UseFormReturn<CADFormModel>;
}

export function Types({ id, rhf, readOnly }: TypesProps) {
	const type = rhf.watch('type');
	if (type === CAD_TYPES.LIST_OF_VALUES) {
		return <Enum id={id} rhf={rhf} readOnly={readOnly} />;
	}
	return <Text id={id} rhf={rhf} readOnly={readOnly} />;
}

Types.displayName = 'Types';
